import axios from 'axios';
import * as Config from '../../config';

const state = {};

const actions = {

    client_contact_store({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'client-contact/store', form)
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error);
                });
        });
    },
    client_contact_get_all({ commit, dispatch }) {
        return new Promise((resolve, reject) => {
            axios.get(Config.apiPath + 'client-contact/get-all')
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error);
                });
        });
    },
    client_contact_switch({ commit, dispatch }, id) {
        return new Promise((resolve, reject) => {
            axios.get(Config.apiPath + 'client-contact/switch/' + id)
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error);
                });
        });
    },
    client_contact_archive({ commit, dispatch }, id) {
        return new Promise((resolve, reject) => {
            axios.get(Config.apiPath + 'client-contact/archive/' + id)
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error);
                });
        });
    },
    client_contact_get_quantity_pending({ commit, dispatch }) {
        return new Promise((resolve, reject) => {
            axios.get(Config.apiPath + 'client-contact/get-quantity-pending')
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error);
                });
        });
    },
};

const mutations = {};

export default {
    state,
    actions,
    mutations
};